import React from 'react'
import styles from './ButtonGroup.scss'
import cx from 'classnames'

export class ButtonGroup extends React.PureComponent {
  render () {
    const { options, selected, flex, squish, onChange } = this.props
    return (
      <div className={cx(styles.ButtonGroup, flex && styles.flex, squish && styles.squish)}>
        {options.map((v, k) =>
          <GroupItem v={v} k={k} key={k} selected={k === selected} onChange={onChange} />
        ).toIndexedSeq()}
      </div>
    )
  }
}

const GroupItem = ({ v, k, selected, onChange }) => (
  <button
    data-content={v}
    className={cx(styles.groupItem, selected && styles.selected)}
    onClick={e => { e.preventDefault(); onChange(k) }} >
    {v}
  </button>
)
